const InputHeader = ({headerStr, headerColor}) => {
  return (
    <>
      <h4 className={`rb14m ${headerColor ? headerColor : "c-black10"} headerInput`} style={{ marginBottom: 4 }}>
        {headerStr}        
      </h4>
    </>
  );
};
export default InputHeader;
